/**
 * 🔥 뜨는것/식는것 갈라놓기 — 시장탭 쉬움 모드의 "요즘 돈이 몰리는 곳 / 빠지는 곳".
 *
 * 옛 버그: `cold = secs.slice(-2)`라서 업종이 3개면 2위가 ▲와 ▼ 양쪽에,
 * 2개면 둘 다, 1개면 그 하나가 양쪽에 동시에 떴다(같은 부모 아래 React key 중복도 함께).
 * 지금은 hot(위쪽 2개)을 먼저 떼고 **남은 것에서만** cold를 고른다 — 겹침이 원천적으로 불가능.
 *
 * 전제: 입력은 avg_rs 내림차순(백엔드 compute_sector_leadership이 reverse=True로 정렬해 보냄).
 */
export function splitHotCold<T>(secs: T[]): { hot: T[]; cold: T[] } {
  const hot = secs.slice(0, 2);
  // 앞 2개(hot)를 건너뛴 뒤의 꼬리 2개만 cold 후보 → 겹침 0. reverse로 '가장 나쁜 것'이 먼저.
  const cold = secs.slice(Math.max(2, secs.length - 2)).reverse();
  return { hot, cold };
}
